import React from 'react';
import { COLORS } from '../../../config/designSystem/Colors';
import {Stack} from 'expo-router';
import { assistanceKey, instantHelpStackKey, organizationAssistanceKey, psychologistDetailKey, yourNextAppointmentKey } from '../../../constants/routeKeys';
import { title } from '../../../components/Root/title';


export default function Layout(){



  return (
    <Stack screenOptions={({route}) => {
      return({
        headerShown: false,
        title: title(route.name),
        contentStyle: {
          backgroundColor: COLORS.surface.primary
        }
      });}
    }>
      <Stack.Screen name={assistanceKey}  />
      <Stack.Screen name={organizationAssistanceKey}  />

      <Stack.Screen name={psychologistDetailKey}  />
      <Stack.Screen name={instantHelpStackKey}  />

      <Stack.Screen name={yourNextAppointmentKey} />

    </Stack>
  );
}
